import React, { useState, ChangeEvent, useEffect, useContext } from 'react';
import { Form, Container, Row, Modal, Button, Alert } from 'react-bootstrap';
import civisLogo from '../../../assets/images/civisLogo.svg';
import signupImg from '../../../assets/images/3docs.jpg';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { registerAsync, selectStateValues } from '../../../app/hospitalRedux/userSlice';
import classes from './authstyle.module.css';
import HospReg from './hopsReg';
import AdminReg from './adminReg';
import CreatePassword from './createPassword';
import Swal from 'sweetalert2';
import { useFormik, FormikProvider, Formik } from 'formik';
import * as yup from 'yup';
import FlexButton from '../../../components/elements/FlexButton';
import { getAllCountries, getAllStates, getRc } from './reqAuth';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { TIMEZONES } from '../../../constants';

export const Toast = Swal.mixin({
	toast: true,
	position: 'top-right',
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.addEventListener('mouseenter', Swal.stopTimer);
		toast.addEventListener('mouseleave', Swal.resumeTimer);
	},
});

const { REACT_APP_BASEURL } = process.env;

const config = {
  headers: {
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': 'https://auth-uat.civishealth.com, http://localhost:3000',
  },
};

const Signup = () => {
	const [showAdmin, setshowAdmin] = useState(false);
	const [showHosp, setShowHosp] = useState(true);
	const [createPassword, setCreatePassword] = useState(false);

	const [hosLoading, setHosLoading] = useState(false);
	const [submitLoading, setSubmitLoading] = useState(false);

	const [password, setPassword] = useState('');
	const [passwordAgain, setPasswordAgain] = useState('');
	const [isChecked, setIsChecked] = useState(false);
	const [passValidation, setPassValidation] = useState(false);

	const [selectedValues, setSelectedValues] = useState<any>([]);

	const history = useHistory();

	const initialVal = {
		name: '',
		address: '',
		// categories:[],
		country: '',
		state: '',
		timeZoneLabel: '',
		timeZoneOffset: '',
		city: '',
		rcCode: '',
	};

	const initialAdmin = {
		fullname: '',
		phoneNumber: '',
		email: '',
		country: '',
		state: '',
		city: '',
		address: '',
		dialcode: '',
		gender: '',
	};

	const [hospitalValue, setHospitalValue] = useState<typeof initialVal>(initialVal);
	const [adminValue, setAdminValue] = useState<typeof initialAdmin>(initialAdmin);

	const validationSchema = yup.object({
		name: yup.string().required('Hospital Name is a required field *').trim().min(2),
		address: yup.string().trim().required('Address is a required field *').min(3),
		// categories:yup.array().required('Category is a required field').nullable().min(1),
		country: yup.string().required('Country is a required field *'),
		state: yup.string().required('State is a required field *'),
		timeZoneLabel: yup.string().required('Timezone is a required field *'),
		city: yup.string().required('City is a required field *'),
		rcCode: yup.string().required('Rc code is a required field *'),
	});

	const validationAdmin = yup.object({
		fullname: yup.string().trim().required('Full Name is a required, must include a Last Name *').min(2),
		phoneNumber: yup
			.string()
			.required('Phone Number is a required field *')
			.matches(/^[0-9]+$/, 'Must be only digits *')
			.min(8, 'minimum must be 8 characters *')
			.max(17, 'maximum must be 17 characters *'),
		address: yup.string().trim().required('Address is a required field *').min(2),
		email: yup.string().email('Must be a valid email').required('Email is a required field *'),
		dialcode: yup.string().required('Dial Code is a required field *'),
		country: yup.string().required('Country is a required field *'),
		state: yup.string().required('State is a required field *'),
		city: yup.string().required('City is a required field *'),
		
		gender: yup.string(),
	});

	let showText = '';
	if (showHosp) {
		showText = 'Account Registration';
	} else if (showAdmin) {
		showText = 'Admin Registration';
	} else if (createPassword) {
		showText = 'Create Password';
	}

	const letSubmit = async (values: typeof initialVal) => {
		if (selectedValues.length == 0) {
			Toast.fire({
				icon: 'warning',
				title: 'Hospital must have a specialization',
			});
		} else {
			try {
				setHosLoading(true);
				const rcCode: any = await getRc(values.rcCode);
				if (rcCode?.does_hospital_exist === false) {
					setShowHosp(false);
					setHosLoading(false);
					setshowAdmin(true);
				} else {
					setHosLoading(false);
					Toast.fire({
						icon: 'warning',
						title: 'Hospital Already Exists',
					});
				}
			} catch (error) {
				setHosLoading(false);
				Toast.fire({
					icon: 'warning',
					title: 'Kindly try again',
				});
			}
		}
	};

	const onSubmit = async () => {
		setSubmitLoading(true);
		const data = {
			user: {
				...adminValue,
				title: adminValue.gender == 'Male' ? 'Mr' : 'Ms',
				password: password,
			},
			hospital: {
				...hospitalValue,
				specializations: selectedValues,
			},
		};

		const val = {
			client_name: adminValue.fullname,
			sender_name: 'Civis Health App',
			to: adminValue.email,
			from: 'civishealth@email.com',
			hospital_name: hospitalValue.name,
		};
		localStorage.setItem('signupInfo', JSON.stringify(val));
		try {
			const converted = JSON.stringify(data);
			console.log('here is me now: ', converted);
			const res: any = await axios.post(`${REACT_APP_BASEURL}hospitals`, data, config);

			if (res?.data?.success) {
				setSubmitLoading(false);
				localStorage.setItem('email', adminValue.email);
				history.push(`/${history.location.pathname.split('/')[1]}/email`);
			}
		} catch (error: any) {
			console.log(error.response);
			setSubmitLoading(false);
			Toast.fire({
				icon: 'warning',
				title: 'error occured',
			});
		}
	};

	return (
		<div
			style={{
				minHeight: '100vh',
				background: `url(${signupImg}) center/cover no-repeat`,
				backgroundColor: '#f8fafc',
				position: 'relative',
				overflow: 'hidden',
			}}
		>
			{/* Background Overlay */}
			<div
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					background: 'linear-gradient(135deg, rgba(15, 78, 113, 0.2) 0%, rgba(15, 78, 113, 0.15) 100%)',
					zIndex: 1,
				}}
			></div>

			{/* Decorative Elements */}
			<div
				style={{
					position: 'absolute',
					top: '15%',
					left: '5%',
					width: '120px',
					height: '120px',
					background: 'linear-gradient(45deg, rgba(15, 78, 113, 0.2), rgba(26, 90, 122, 0.2))',
					borderRadius: '50%',
					filter: 'blur(40px)',
					animation: 'float 6s ease-in-out infinite',
					zIndex: 2,
				}}
			></div>
			<div
				style={{
					position: 'absolute',
					bottom: '15%',
					right: '8%',
					width: '160px',
					height: '160px',
					background: 'linear-gradient(45deg, rgba(26, 90, 122, 0.2), rgba(15, 78, 113, 0.2))',
					borderRadius: '50%',
					filter: 'blur(50px)',
					animation: 'float 8s ease-in-out infinite reverse',
					zIndex: 2,
				}}
			></div>

			{/* Header */}
			<div
				style={{
					background: 'rgba(255, 255, 255, 0.95)',
					backdropFilter: 'blur(20px)',
					WebkitBackdropFilter: 'blur(20px)',
					borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
					boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
					position: 'relative',
					zIndex: 10,
					padding: '1rem 0',
					height: '50px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					transition: 'background 0.3s ease',
				}}
			>
				<div className="text-center">
					<img src={civisLogo} width="120px" alt="logo" style={{ filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))' }} />
				</div>
			</div>

			{/* Main Content */}
			<div
				style={{
					position: 'relative',
					zIndex: 15,
					minHeight: 'calc(100vh - 100px)',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-start',
					padding: '2rem',
					paddingLeft: '5%',
				}}
			>
				{/* Main Card Container */}
				<div
					style={{
						background: 'transparent',
						backdropFilter: 'blur(30px)',
						WebkitBackdropFilter: 'blur(30px)',
						borderRadius: '20px',
						padding: '2rem',
						maxWidth: '520px',
						width: '100%',
						maxHeight: '85vh',
						height: 'auto',
						overflowY: 'auto',
						boxShadow: `
							0 20px 60px rgba(15, 78, 113, 0.3),
							0 8px 25px rgba(15, 78, 113, 0.2),
							inset 0 1px 0 rgba(255, 255, 255, 0.6)
						`,
						border: '1px solid rgba(15, 78, 113, 0.1)',
						position: 'relative',
						transform: 'translateY(0)',
						transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
					}}
					className="signup-card"
				>
					{/* Card Glow Effect */}
					<div
						style={{
							position: 'absolute',
							// top: '-3px',
							// left: '-3px',
							// right: '-3px',
							// bottom: '-300px',
							// background: 'linear-gradient(135deg, #0F4E71, #1a5a7a, #0F4E71)',
							borderRadius: '23px',
							zIndex: -1,
							opacity: 0.7,
							filter: 'blur(8px)',
						}}
					></div>

					{/* Form Header */}
					<div style={{
						textAlign: 'center',
						marginBottom: '1.5rem',
						background: 'linear-gradient(145deg, #ffffff 0%, #fefefe 50%, #ffffff 100%)',
						backdropFilter: 'blur(10px)',
						WebkitBackdropFilter: 'blur(10px)',
						padding: '1.5rem 1rem',
						borderRadius: '16px',
						boxShadow: `
							0 8px 32px rgba(15, 78, 113, 0.12),
							0 4px 16px rgba(0, 0, 0, 0.08),
							inset 0 1px 0 rgba(255, 255, 255, 0.9),
							inset 0 -1px 0 rgba(0, 0, 0, 0.03)
						`,
						border: '1px solid rgba(255, 255, 255, 0.8)',
						position: 'relative',
						transform: 'translateZ(0)',
						transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
					}}>
						{/* 3D Card Inner Glow */}
						<div style={{
							position: 'absolute',
							top: '1px',
							left: '1px',
							right: '1px',
							bottom: '1px',
							background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.9), rgba(248, 250, 252, 0.6))',
							borderRadius: '15px',
							zIndex: -1,
							pointerEvents: 'none',
						}}></div>
						<div
							style={{
								width: '50px',
								height: '50px',
								background: 'linear-gradient(135deg, #0F4E71 0%, #1a5a7a 100%)',
								borderRadius: '50%',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								margin: '0 auto 0.75rem',
								boxShadow: '0 6px 20px rgba(15, 78, 113, 0.4)',
								position: 'relative',
							}}
						>
							<div
								style={{
									position: 'absolute',
									top: '-6px',
									left: '-6px',
									right: '-6px',
									bottom: '-6px',
									border: '2px solid rgba(15, 78, 113, 0.3)',
									borderRadius: '50%',
									animation: 'pulse 2s infinite',
								}}
							></div>
							<svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</div>
						<h4
							style={{
								fontSize: '1.6rem',
								fontWeight: '700',
								background: 'linear-gradient(135deg, #0F4E71 0%, #1a5a7a 100%)',
								WebkitBackgroundClip: 'text',
								WebkitTextFillColor: 'transparent',
								backgroundClip: 'text',
								marginBottom: '0.25rem',
								letterSpacing: '-0.02em',
							}}
						>
							{showText}
						</h4>
						<p style={{ color: '#066F6B', fontSize: '0.9rem', margin: '0' }}>
							{showHosp && <span> Register your medical institution on <span style={{ color: '#0f4e71' }}>Civis</span><span style={{ color: '#3CB64A' }}>Health</span>								
							</span>}
							{showAdmin && 'Create your administrator account'}
							{createPassword && 'Secure your account with a strong password'}
						</p>
					</div>

					{/* Form Content */}
					<div style={{ position: 'relative' }}>
						{showHosp && (
							<Formik
								enableReinitialize={true}
								validationSchema={validationSchema}
								validateOnChange={true}
								initialValues={initialVal}
								onSubmit={(data: typeof initialVal) => {
									letSubmit(data);
									setHospitalValue({ ...data, timeZoneOffset: TIMEZONES.find((zone) => zone.label === data.timeZoneLabel)?.utc || '' });
								}}
							>
								{({ values, errors, handleChange, isValid, isInitialValid, isSubmitting, handleSubmit }) => (
									<form className="py-3" onSubmit={handleSubmit} style={{ padding: '0' }}>
										<HospReg selectedValues={selectedValues} setSelectedValues={setSelectedValues} values={values} hospLoading={hosLoading} />
									</form>
								)}
							</Formik>
						)}

						{showAdmin && (
							<Formik
								enableReinitialize={true}
								validationSchema={validationAdmin}
								validateOnChange={true}
								initialValues={initialAdmin}
								onSubmit={(data: typeof initialAdmin) => {
									setAdminValue(data);
									setshowAdmin(false);
									setCreatePassword(true);
								}}
							>
								{({ values, errors, handleChange, isValid, isInitialValid, isSubmitting, handleSubmit }) => (
									<form className="py-3" onSubmit={handleSubmit} style={{ padding: '0' }}>
										<AdminReg values={values} adminLoading={hosLoading} />
									</form>
								)}
							</Formik>
						)}

						{createPassword && (
							<CreatePassword
								setPassword={setPassword}
								setPasswordAgain={setPasswordAgain}
								passwordValue={password}
								passwordAgain={passwordAgain}
								submitAllform={onSubmit}
								setIsChecked={setIsChecked}
								isChecked={isChecked}
								setPassValidation={setPassValidation}
								passValidation={passValidation}
								submitLoading={submitLoading}
							/>
						)}
					</div>

					{/* Footer */}
					{showHosp && (
						<div
							style={{
								textAlign: 'center',
								marginTop: '1.5rem',
								paddingTop: '1rem',
								borderTop: '1px solid rgba(15, 78, 113, 0.1)',
							}}
						>
							<p style={{ fontSize: '1rem', color: '#FFFFFF', margin: '0' }}>
								Already have an Account?{' '}
								<span
									style={{
										color: '#0F4E71',
										fontWeight: '700',
										cursor: 'pointer',
										textDecoration: 'none',
										transition: 'all 0.2s ease',
										fontSize: '1rem',
									}}
									onClick={() => history.push('/hospital/login')}
									onMouseEnter={(e) => {
										e.currentTarget.style.textDecoration = 'underline';
										e.currentTarget.style.color = '#1a5a7a';
									}}
									onMouseLeave={(e) => {
										e.currentTarget.style.textDecoration = 'none';
										e.currentTarget.style.color = '#0F4E71';
									}}
								>
									Sign In
								</span>
							</p>
						</div>
					)}
				</div>
			</div>

			{/* CSS Animations */}
			<style>{`
				@keyframes float {
					0%, 100% { transform: translateY(0px) rotate(0deg); }
					50% { transform: translateY(-20px) rotate(10deg); }
				}
				
				@keyframes pulse {
					0% { transform: scale(1); opacity: 1; }
					50% { transform: scale(1.05); opacity: 0.7; }
					100% { transform: scale(1.1); opacity: 0; }
				}
				
				.signup-card:hover {
					transform: translateY(-5px);
					box-shadow: 
						0 25px 80px rgba(15, 78, 113, 0.4),
						0 12px 35px rgba(15, 78, 113, 0.3),
						inset 0 1px 0 rgba(255, 255, 255, 0.6);
				}

				/* Custom Scrollbar */
				.signup-card::-webkit-scrollbar {
					width: 6px;
				}
				
				.signup-card::-webkit-scrollbar-track {
					background: rgba(15, 78, 113, 0.1);
					border-radius: 3px;
				}
				
				.signup-card::-webkit-scrollbar-thumb {
					background: linear-gradient(135deg, #0F4E71, #1a5a7a);
					border-radius: 3px;
				}
				
				.signup-card::-webkit-scrollbar-thumb:hover {
					background: linear-gradient(135deg, #1a5a7a, #0F4E71);
				}

				/* Modern Form Styling */
				.signup-card .form-control {
					background: #f8fafc !important;
					border: 2px solid #e2e8f0 !important;
					border-radius: 10px !important;
					padding: 10px 14px !important;
					font-size: 14px !important;
					font-weight: 500 !important;
					color: #1e293b !important;
					transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
					box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
				}

				.signup-card .form-control:focus {
					background: #ffffff !important;
					border-color: #0F4E71 !important;
					box-shadow: 
						0 0 0 3px rgba(15, 78, 113, 0.1),
						0 4px 12px rgba(15, 78, 113, 0.15) !important;
					outline: none !important;
					transform: translateY(-1px);
				}

				.signup-card .form-control:hover:not(:focus) {
					border-color: #94a3b8 !important;
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
				}

				.signup-card .form-control::placeholder {
					color: #94a3b8 !important;
					font-weight: 400 !important;
				}

				/* Select Styling */
				.signup-card select.form-control {
					background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23334155' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e") !important;
					background-repeat: no-repeat !important;
					background-position: right 12px center !important;
					background-size: 16px !important;
					padding-right: 40px !important;
				}

				/* Label Styling */
				.signup-card .form-label,
				.signup-card label {
					color: #374151 !important;
					font-weight: 600 !important;
					font-size: 13px !important;
					margin-bottom: 6px !important;
					letter-spacing: -0.01em !important;
				}

				/* Button Styling */
				.signup-card .btn-primary {
					background: linear-gradient(135deg, #0F4E71 0%, #1a5a7a 100%) !important;
					border: none !important;
					border-radius: 10px !important;
					padding: 10px 20px !important;
					font-weight: 600 !important;
					font-size: 14px !important;
					transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
					box-shadow: 0 4px 12px rgba(15, 78, 113, 0.3) !important;
				}

				.signup-card .btn-primary:hover {
					transform: translateY(-2px) !important;
					box-shadow: 0 8px 25px rgba(15, 78, 113, 0.4) !important;
					background: linear-gradient(135deg, #1a5a7a 0%, #0F4E71 100%) !important;
				}

				.signup-card .btn-primary:active {
					transform: translateY(0) !important;
				}

				/* Error Message Styling */
				.signup-card .invalid-feedback,
				.signup-card .text-danger {
					color: #dc2626 !important;
					font-size: 11px !important;
					font-weight: 500 !important;
					margin-top: 3px !important;
				}

				/* Form Group Spacing */
				.signup-card .form-group,
				.signup-card .mb-3 {
					margin-bottom: 1rem !important;
				}

				/* Custom Checkbox Styling */
				.signup-card .form-check-input {
					border: 2px solid #e2e8f0 !important;
					border-radius: 6px !important;
					width: 16px !important;
					height: 16px !important;
					background-color: #f8fafc !important;
				}

				.signup-card .form-check-input:checked {
					background-color: #0F4E71 !important;
					border-color: #0F4E71 !important;
				}

				.signup-card .form-check-label {
					color: #374151 !important;
					font-size: 13px !important;
					font-weight: 500 !important;
					margin-left: 6px !important;
				}
			`}</style>
		</div>
	);
};

export default Signup;
